/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
/* eslint-disable arrow-body-style */
import React, { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog,  DialogTitle, DialogContent, DialogActions, TextField, Grid, MenuItem, Select, InputLabel, FormControl, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import adminServices from '../../../services/adminServices';

const CreateSourceDialog = ({ open, editdetails, onClose,onNotify, assessmentTypeList }) => {
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  const [isCreatingSource, setIsCreatingSource] = useState(false);
  const [isUpdatingSource, setIsUpdatingSource] = useState(false);

  const [formData, setFormData] = useState({
    sourceName: "",
    description: "",
    category: "",
    targetExam: "",
    difficulty: "easy",
    status: "Draft",
  });

  const decodeHTML = (raw) => {
    const doc = new DOMParser().parseFromString(raw || '', 'text/html');
    return doc.body.textContent?.trim() || '';
  };

  useMemo(() => {
    if (editdetails) {
      setFormData({
        sourceName: decodeHTML(editdetails?.title),
        description: decodeHTML(editdetails?.short_description),
        category: editdetails?.type,
        targetExam: editdetails?.target_exam,
        difficulty: editdetails?.complexity_level,
        status: editdetails?.status_type === 2 ? 'Draft' : 'Active',
      });
    }
  }, [editdetails])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value, }));
    setErrors((prev) => ({ ...prev, [name]: "", }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.sourceName.trim()) {
      newErrors.sourceName = "Source name is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateSource = async () => {
    if (!validateForm()) return;
    try {
      setIsCreatingSource(true);
      const body = {
        name: formData.sourceName,
        description: formData.description,
        category: formData.category,
        targetExam: formData.targetExam,
        difficulty: formData.difficulty,
        status: formData.status
      };
      const result = await adminServices.AssessmentSourceCreation(body);
      if (result.ok) 
        {
        onNotify?.("Source created successfully");
        setFormData({
          sourceName: "",
          description: "",
          category: "SAT",
          targetExam: "",
          difficulty: "easy",
          status: "Draft",
        });
        onClose();
        setErrors({});
      }

    } finally {
      setIsCreatingSource(false);
    }
  };


  const handleUpdateSource = async () => {
    if (!validateForm()) return;
    try {
      setIsUpdatingSource(true);
      const body = {
        name: formData.sourceName,
        description: formData.description,
        category: formData.category,
        targetExam: formData.targetExam,
        difficulty: formData.difficulty,
        status: formData.status
      };
      const result = await adminServices.UpdateSourceCreation(body, editdetails?.id);
      if (result.ok)
        {
        onNotify?.("Source updated successfully");
        setFormData({
          sourceName: "",
          description: "",
          category: "SAT",
          targetExam: "",
          difficulty: "easy",
          status: "Draft",
        });
        setErrors({});
        onClose();
      }

    } finally {
      setIsUpdatingSource(false);
    }
  };

  const handleCloseForm = () => {
    setFormData({
      sourceName: "",
      description: "",
      category: "SAT",
      targetExam: "",
      difficulty: "easy",
      status: "Draft",
    });
    onClose()
    setErrors({});
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseForm}
      fullWidth maxWidth='sm'
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(6px)',
          backgroundColor: 'rgba(0,0,0,0.4)'
        }
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6">{editdetails ? 'Edit' : 'Create'} New Source</Typography>
        <IconButton id="close-source-dialog-btn" onClick={handleCloseForm}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
  dividers
  sx={{padding: "20px 24px",'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: '#1D4ED8',},
    '& .MuiInputLabel-root.Mui-focused': {color: '#1D4ED8',},
    '& .MuiSelect-select:focus': {backgroundColor: 'transparent',},}}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              id='source-name-input'
              name='sourceName'
              value={formData.sourceName}
              onChange={handleChange}
              label="Source Name *"
              placeholder="e.g. Physics - NEET 2024"
              fullWidth
              error={!!errors.sourceName}
              helperText={errors.sourceName}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              id='source-description-input'
              name='description'
              value={formData.description}
              onChange={handleChange}
              label="Description"
              placeholder="Detailed description of the source..."
              fullWidth
              multiline
              rows={3}
              error={!!errors.description}
              helperText={errors.description}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Category *</InputLabel>
              <Select id='source-category-select' name='category' onChange={handleChange} label="Category *" value={formData.category} disabled={!!editdetails}>
                {assessmentTypeList.map((item) => (
                 <MenuItem key={item.id} value={item.code}>
                    {item.description || item.code}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              id='source-target-exam-input'
              name='targetExam'
              value={formData.targetExam}
              onChange={handleChange}
              label="Target Exam"
              placeholder="e.g. NEET 2024"
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Difficulty Level</InputLabel>
              <Select id='source-difficulty-select' name='difficulty' value={formData.difficulty} onChange={handleChange} label="Difficulty Level">
                <MenuItem value="easy">Easy</MenuItem>
                <MenuItem value="medium">Medium</MenuItem>
                <MenuItem value="hard">Hard</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select id='source-status-select' name='status' value={formData.status} label="Status" onChange={handleChange} >
                <MenuItem value="Draft">Draft</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            {/* <div className="mb-3 mt-2">
             <h6 className="text-base font-bold mt-1 text-[rgb(183_139_16)]">
                You can add chapters from Actions column in the Source Table
              </h6>
            </div> */}
            <div className="flex items-center gap-2 bg-[#FFF8E1] border border-[#FFE082] rounded-lg px-4 py-2 mb-3 mt-2">
              <span className="text-[rgb(183_139_16)] text-lg mb-1">⚠️</span>

              <p className="text-sm font-medium text-[rgb(183_139_16)]">
                You can add chapters from Actions column in the Source Table
              </p>
            </div>

          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ padding: "16px 24px", justifyContent: "flex-end", gap: 2 }}>
        <button id="cancel-source-btn" onClick={handleCloseForm} className=" border border-[#e5e7eb] bg-white
 hover:bg-white-700 text-black px-5 py-2.5 rounded-lg font-medium flex items-center justify-center gap-2 transition-all duration-200 w-full sm:w-auto shadow-sm hover:shadow-md">
          {t('Cancel')}
        </button>
        {editdetails ?
          <button
            id="update-source-btn"
            onClick={handleUpdateSource}
            disabled={isUpdatingSource}
            className={`bg-indigo-600 text-white px-5 py-2.5 rounded-lg font-medium
        flex items-center justify-center gap-2 transition-all duration-200
        w-full sm:w-auto shadow-sm hover:shadow-md
        ${isUpdatingSource ? "opacity-60 cursor-not-allowed" : "hover:bg-indigo-700"}`}
          >
            {isUpdatingSource ? (
              <>
                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                </svg>
                Updating...
              </>
            ) : (
              t('Update Source')
            )}
          </button>
          :
          <button id="create-source-btn" onClick={handleCreateSource} disabled={isCreatingSource} className={`bg-indigo-600 text-white px-5 py-2.5 rounded-lg font-medium flex items-center justify-center gap-2 transition-all duration-200
          w-full sm:w-auto shadow-sm hover:shadow-md ${isCreatingSource ? "opacity-60 cursor-not-allowed" : "hover:bg-indigo-700"}`}>
            {isCreatingSource ? (
              <>
                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" >
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                </svg> Creating...
              </>
            ) : (
              t('Create Source')
            )}
          </button>

        }
      </DialogActions>
    </Dialog>
  );
};

export default CreateSourceDialog;